<template>
  <div class="card">
    <div class="card-body">
      <form @submit.prevent="createUnitProduct">
        <div>
          <multiselect
            v-model="unitProduct.product"
            tag-placeholder="Add this as new tag"
            :taggable="true"
            @tag="addTag"
            @update="updateSelected"
            :searchable="true"
            :close-on-select="true"
            label="name"
            track-by="id"
            :placeholder="$t('selectOneProduct')"
            :options="productNames"
            :option-height="104"
          >
            <template slot="singleLabel" slot-scope="props"
              ><img
                class="option_image"
                :src="`${props.option.img_path}`"
                alt="image"
              /><span class="option_title"
                ><span class="option_title">{{ props.option.name }}</span></span
              ></template
            >
            <template slot="option" slot-scope="props"
              ><img
                class="option_image"
                :src="`${props.option.img_path}`"
                alt="image"
              />
              <div class="option_title">
                <span>{{ props.option.name }}</span>
              </div>
            </template>
          </multiselect>
          <div v-if="productNames.length === 0" class="errorMessage">
            <br />
            {{ $t('informAddProduct') }}
          </div>
          <br />
        </div>

        <BaseInput
          class="field"
          v-model="unitProduct.stock_max"
          type="number"
          :placeholder="$t('maxStock')"
          :class="{ error: $v.unitProduct.stock_max.$error }"
          @blur="$v.unitProduct.stock_max.$touch()"
        />

        <template v-if="$v.unitProduct.stock_max.$error">
          <p v-if="!$v.unitProduct.stock_max.required" class="errorMessage">
            {{ $t('maxStockReq') }}
          </p>
        </template>

        <BaseInput
          class="field"
          v-model="unitProduct.stock_curr"
          type="number"
          :placeholder="$t('currentStock')"
          :class="{ error: $v.unitProduct.stock_curr.$error }"
          @blur="$v.unitProduct.stock_curr.$touch()"
        />

        <template v-if="$v.unitProduct.stock_curr.$error">
          <p v-if="!$v.unitProduct.stock_curr.required" class="errorMessage">
            {{ $t('currentStockReq') }}
          </p>
        </template>

        <div class="optionalData">
          <p class="optional">{{ $t('optional') }}</p>
          <b-form-textarea
            class="field form-control"
            aria-label="With textarea"
            v-model="unitProduct.comments"
            maxlength="300"
            type="text"
            :placeholder="$t('unitProductComm')"
          ></b-form-textarea>
        </div>

        <button
          type="submit"
          buttonClass="-fill-gradient"
          :disabled="$v.$anyError"
          class="add-btn"
        >
          {{ $t('add') }}
        </button>
        <p v-if="$v.anyError" class="errorMessage">
          {{ $t('fillInReq') }}
        </p>
      </form>
    </div>
    <sweet-modal
      icon="error"
      title="Oh nooo…"
      name="errorModal"
      ref="modalError"
    >
      {{ errorMessage }}
      <sweet-button slot="button">{{ $t('tryAgain') }}</sweet-button>
    </sweet-modal>
  </div>
</template>

<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import NProgress from 'nprogress'
// import ProductService from '@/services/ProductService.js'
// import ImgUpload from '@/components/ui/ImgUpload.vue'
import { required } from 'vuelidate/lib/validators'

export default {
  components: {
    // ImgUpload,
    Multiselect
  },
  data() {
    return {
      productNames: null,
      productName: [],
      unitProduct: this.createFreshUnitProductObject(),
      selectedFile: null,
      unit: [],
      baseUrl: process.env.VUE_APP_API_URL,
      errorMessage: null
    }
  },
  validations: {
    unitProduct: {
      product: { required },
      comments: {},
      stock_max: { required },
      stock_curr: { required }
    }
  },
  async created() {
    const response = await axios.get(
      `${process.env.VUE_APP_API_URL}/available/products/unit/` +
        this.unitProduct.unit.id
    )
    this.productNames = response.data
  },
  mounted() {
    this.createFreshUnitProductObject()
  },
  methods: {
    createUnitProduct() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        NProgress.start()
        this.$store
          .dispatch('unitProduct/createUnitProduct', this.unitProduct)
          .then(() => {
            this.$router.push({
              name: 'unitProduct',
              params: {
                unitId: this.unitProduct.unit.id,
                productId: this.unitProduct.product.id
              }
            })
          })
          .catch(err => {
            if (err.message !== undefined && err.message === 'notEnoughStock')
              this.errorMessage = this.$t('notEnoughProductStock')
            else this.errorMessage = this.$t('errorMsg')
            NProgress.done()
            this.$refs.modalError.open()
          })
      }
    },
    createFreshUnitProductObject() {
      const client = this.$store.state.client.client
      const unit = this.$store.state.unit.unit
      const id = Math.floor(Math.random() * 1000000)

      return {
        id: id,
        client: client,
        unit: unit,
        product: '',
        comments: '',
        stock_max: '',
        stock_curr: '',
        stock_actual: ''
        // unit_productImage: ''
      }
    },
    updateSelected: function(newSelected) {
      this.selected = newSelected
    },
    addTag: function(newTag) {
      this.productNames.push(newTag)
      this.selected.push(newTag)
    }
  }
}
</script>

<style scoped>
@import '../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css';

textarea {
  height: 180px;
}

.optionalData {
  background-color: var(--grey-light);
  border: 1px solid var(--grey);
  padding: 0 20px;
  width: 100%;
}
.optional {
  text-align: center;
  letter-spacing: 5px;
  color: var(--bg);
}

.card-body {
  color: #454655;
}
.field {
  margin-bottom: 24px;
}

.card-title {
  font-size: 30px;
}
p {
  text-align: left;
}
.errorMessage {
  font-size: 0.8em;
  margin-top: -10px;
  color: var(--primaryDark);
}

.add-btn {
  margin-top: 1em;
  background: var(--primaryDark);
  color: var(--bright);
  padding: 0.5em;
  letter-spacing: 3px;
  width: 80%;
  border-radius: 5px;
  text-transform: uppercase;
}

.option_image {
  height: 50px;
  width: 50px;
  display: inline;
}

.option_title {
  display: inline;
  margin-left: 5px;
}

@media screen and (max-width: 560px) {
  button {
    padding: 10px 60px 10px 60px;
  }
  form {
    width: 100%;
  }
  .optionalData {
    padding: 10px;
  }
  textarea {
    width: 100%;
    height: 100px;
  }
}
</style>
